/**
 * 活动页面本地兜底配置
 */
import type { ActivityHomeConfig } from './types';
import { ComponentTypeEnum, CustomClickEventNameEnum } from './enums';

/**
 * 默认兜底配置
 */
export const DEFAULT_FALLBACK_CONFIG: ActivityHomeConfig = {
  name: '活动首页01',
  orderComponents: [
    {
      componentType: ComponentTypeEnum.NAV_BAR,
      title: '哈啰臻有钱',
      titleIsCenter: true,
    },
    {
      componentType: ComponentTypeEnum.ATMOSPHERIC_HEADER,
      containerStyle: {
        width: '375px',
        height: '438px',
      },
      backgroundImage: {
        default: 'https://m.hellobike.com/b7079f40_activity-home-01_atmospheric-header_a.png',
        webp: 'https://m.hellobike.com/932da5e5_activity-home-01_atmospheric-header_a.webp',
      },
      customClick: {
        eventName: CustomClickEventNameEnum.JUMP_TO_CREDIT,
        ubtModuleId: 'finance_loan_activityHome_topPicture',
      },
    },
    {
      componentType: ComponentTypeEnum.COMMON_STATIC_RECTANGLE,
      containerStyle: {
        width: '375px',
        height: '112px',
      },
      backgroundImage: {
        default: 'https://m.hellobike.com/2105c5ff_activity-home-01_static-rectangle_apply-button.gif',
      },
      customClick: {
        eventName: CustomClickEventNameEnum.JUMP_TO_CREDIT,
        ubtModuleId: 'finance_loan_activityHome_middlePicture',
      },
    },
    {
      componentType: ComponentTypeEnum.COMMON_STATIC_RECTANGLE,
      containerStyle: {
        width: '375px',
        height: '293.7px',
      },
      backgroundImage: {
        default: 'https://m.hellobike.com/5ec0bded_activity-home-01_static-rectangle_footer.png',
      },
    },
    {
      componentType: ComponentTypeEnum.COMMON_FIXED_RECTANGLE,
      containerStyle: {
        position: 'fixed',
        bottom: '108px',
        right: '0',
        width: '64px',
        height: '64px',
      },
      backgroundImage: {
        default: 'https://m.hellobike.com/82dadb2f_activity-home-01_fixed-rectangle_mine.png',
      },
      customClick: {
        eventName: CustomClickEventNameEnum.JUMP_TO_MINE,
        ubtModuleId: 'finance_loan_activityHome_my',
      },
    },
  ],
};
